import { v4 as uuid } from "uuid";

export type LogoutEvent = {
  message?: string;
  tabId?: string;
};

// create a tab id to uniquely identify this tab
const tabId = uuid();

/** Do not use this directly, it is only exposed for testing */
export const getTabId = () => tabId;

function isLogoutEvent(event: MessageEvent): event is MessageEvent<LogoutEvent> {
  if (event.data && typeof event.data === "object") {
    if (
      "message" in event.data &&
      typeof event.data.message === "string" &&
      "tabId" in event.data &&
      typeof event.data.tabId === "string"
    ) {
      return true;
    }
  }
  return false;
}

/** Do not use this function directly, it is only exposed for testing. Use setupCoordinatedLogout or broadcastLogout */
export function onLogoutBroadcastReceived(event: MessageEvent) {
  // this channel can receive any sort of event, so we need to manually type narrow
  if (isLogoutEvent(event)) {
    if (
      event.data.message === "logout" &&
      // make sure another tab sent the message
      event.data.tabId !== tabId &&
      // if this tab is already on the login page, don't redirect again
      !window.location.pathname.includes("/login")
    ) {
      // another tab has been logged out, so redirect to login page with a return to this page
      window.location.assign(`/login?path=${encodeURIComponent(window.location.pathname)}`);
    }
  }
}

/** When a user logs out of one tab or window, we need to log them out of all tabs/windows */
export function setupCoordinatedLogout() {
  const bc = new BroadcastChannel("jsq-coordinated-logout");
  bc.onmessage = onLogoutBroadcastReceived;
}

/**
 * Broadcast a logout message to all tabs so that they redirect to the login page.
 */
export function broadcastLogout() {
  const bc = new BroadcastChannel("jsq-coordinated-logout");
  const logoutEvent: LogoutEvent = {
    message: "logout",
    tabId,
  };
  bc.postMessage(logoutEvent);
}
